import React, { useState } from "react";

export default function ProductVariants({

    product,

    variants = [],

    onCreate,

    onUpdate,

    onDelete

}) {

    const [editing, setEditing] =
        useState(null);

    const [saving, setSaving] =
        useState(false);

    const emptyVariant = {

        name: "",

        sku: "",

        barcode: "",

        options: {

            size: "",

            color: "",

            material: ""

        },

        price: product?.price || 0,

        comparePrice:
            product?.comparePrice || 0,

        costPrice:
            product?.costPrice || 0,

        stock: 0,

        lowStock: 5,

        trackInventory: true,

        allowBackorder: false,

        weight: 0,

        length_width_height: "",

        status: "active"

    };

    const [form, setForm] =
        useState(emptyVariant);

    const startCreate = () => {

        setEditing(null);

        setForm(emptyVariant);

    };

    const startEdit = variant => {

        setEditing(variant.id);

        setForm({

            ...emptyVariant,

            ...variant,

            options: {

                ...emptyVariant.options,

                ...(variant.options || {})

            }

        });

    };

    const save = async () => {

        try {

            setSaving(true);

            if (editing) {

                await onUpdate(
                    editing,
                    form
                );

            }

            else {

                await onCreate({

                    ...form,

                    product: product.id

                });

            }

            setEditing(null);

            setForm(emptyVariant);

        }

        finally {

            setSaving(false);

        }

    };

    return (

        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 24
            }}
        >

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >

                <div>

                    <h2>
                        Product Variants
                    </h2>

                    <p
                        style={{
                            color: "#666"
                        }}
                    >
                        Manage sizes, colors,
                        materials and variant-level
                        inventory.
                    </p>

                </div>

                <button
                    onClick={startCreate}
                    style={{
                        padding: "12px 20px",
                        border: "none",
                        borderRadius: 10,
                        background:
                            "rgb(255,0,204)",
                        color: "#fff",
                        fontWeight: 700,
                        cursor: "pointer"
                    }}
                >
                    + Add Variant
                </button>

            </div>

            {variants.length === 0 && (

                <div
                    style={{
                        background: "#fff",
                        padding: 30,
                        borderRadius: 14,
                        color: "#777"
                    }}
                >
                    No variants created yet.
                </div>

            )}

            {variants.map(variant => (

                <div
                    key={variant.id}
                    style={{
                        background: "#fff",
                        padding: 20,
                        borderRadius: 14,
                        border: "1px solid #eee",
                        display: "flex",
                        justifyContent:
                            "space-between",
                        alignItems: "center"
                    }}
                >

                    <div>

                        <strong>
                            {variant.name ||
                                "Unnamed Variant"}
                        </strong>

                        <div
                            style={{
                                color: "#777",
                                marginTop: 6
                            }}
                        >
                            SKU: {variant.sku || "—"}
                        </div>

                        <div
                            style={{
                                marginTop: 6
                            }}
                        >
                            Stock: {variant.stock}
                        </div>

                    </div>

                    <div
                        style={{
                            display: "flex",
                            gap: 10
                        }}
                    >

                        <button
                            onClick={() =>
                                startEdit(variant)
                            }
                        >
                            Edit
                        </button>

                        <button
                            onClick={() =>
                                onDelete(variant.id)
                            }
                        >
                            Delete
                        </button>

                    </div>

                </div>

            ))}

            {(editing || form) && (
                <div
                    style={{
                        background: "#fff",
                        padding: 25,
                        borderRadius: 14,
                        border: "1px solid #eee"
                    }}
                >

                    <h3>
                        {editing
                            ? "Edit Variant"
                            : "New Variant"}
                    </h3>

                    <input
                        placeholder="Variant name"
                        value={form.name}
                        onChange={e =>
                            setForm({
                                ...form,
                                name:
                                    e.target.value
                            })
                        }
                    />

                    <input
                        placeholder="SKU"
                        value={form.sku}
                        onChange={e =>
                            setForm({
                                ...form,
                                sku:
                                    e.target.value
                            })
                        }
                    />

                    <input
                        type="number"
                        placeholder="Price"
                        value={form.price}
                        onChange={e =>
                            setForm({
                                ...form,
                                price:
                                    Number(
                                        e.target.value
                                    )
                            })
                        }
                    />

                    <input
                        type="number"
                        placeholder="Stock"
                        value={form.stock}
                        onChange={e =>
                            setForm({
                                ...form,
                                stock:
                                    Number(
                                        e.target.value
                                    )
                            })
                        }
                    />

                    <div
                        style={{
                            display: "flex",
                            gap: 10,
                            marginTop: 20
                        }}
                    >

                        <button
                            onClick={save}
                            disabled={saving}
                        >
                            {saving
                                ? "Saving..."
                                : "Save Variant"}
                        </button>

                        <button
                            onClick={() =>
                                setEditing(null)
                            }
                        >
                            Cancel
                        </button>

                    </div>

                </div>
            )}

        </div>

    );

}